import styled from "styled-components";

const bp = { md: "768px" };

const c = {
  white: "#ffffff",
  ink: "rgba(0,0,0,0.90)",
  inkSoft: "rgba(0,0,0,0.62)",
  line: "rgba(0,0,0,0.12)",
  black: "#141414",
  gold: "#c9a227",
  goldLine: "rgba(201,162,39,0.45)",
};

export const Container = styled.div`
  min-height: 100vh;
  background: ${c.white};
  color: ${c.ink};

  display: flex;
  justify-content: center;
  align-items: center; /* ✅ centru pe desktop */

  padding: 48px 14px 70px;
  position: relative;

  * {
    box-sizing: border-box;
  }

  /* ✅ pe mobil îl coborâm mai jos, dar rămâne centrat frumos */
  @media (max-width: ${bp.md}) {
    align-items: flex-start;
    padding: 78px 14px 90px; /* mai mult sus => cardul coboară */
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;

  width: 44px;
  height: 44px;
  border-radius: 999px;

  border: 1px solid rgba(201, 162, 39, 0.35);
  background: rgba(255, 255, 255, 0.92);
  color: ${c.ink};

  font-size: 22px;
  line-height: 0;
  cursor: pointer;

  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.1);

  &:hover {
    border-color: rgba(201, 162, 39, 0.55);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: ${bp.md}) {
    top: 12px;
    right: 12px;
  }
`;

export const Panel = styled.div`
  width: 94%;
  max-width: 560px;

  background: #fff;
  border-radius: 22px;

  border: 1px solid rgba(201, 162, 39, 0.5);
  box-shadow:
    0 0 0 6px rgba(201, 162, 39, 0.05),
    0 26px 70px rgba(0, 0, 0, 0.1);

  padding: 34px 36px 26px;

  @media (max-width: ${bp.md}) {
    width: 94%;
    padding: 26px 18px 20px;
    border-radius: 20px;
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 18px;
`;

export const Title = styled.h1`
  margin: 6px 0 10px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  letter-spacing: 0.1em;
  font-size: 34px;
  color: rgba(0, 0, 0, 0.92);

  @media (max-width: ${bp.md}) {
    font-size: 28px;
  }
`;

export const Ornament = styled.div`
  position: relative;
  width: 260px;
  height: 14px;
  margin: 6px auto 14px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: ${c.goldLine};
  border-radius: 999px;
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 9px;
  height: 9px;
  transform: translate(-50%, -50%) rotate(45deg);
  background: ${c.gold};
  border-radius: 2px;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 16px;
  letter-spacing: 0.01em;
  color: ${c.inkSoft};
  line-height: 1.6;

  @media (max-width: ${bp.md}) {
    font-size: 15px;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Field = styled.div``;

export const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 800;
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.72);
`;

export const Input = styled.input`
  display: block;
  width: 100%;

  background: #ffffff;
  color: ${c.ink};

  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 14px;

  padding: 12px 14px;
  font-size: 16px;
  outline: none;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    border-color: rgba(201, 162, 39, 0.85);
    box-shadow: 0 0 0 3px rgba(201, 162, 39, 0.12);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  margin-top: 8px;

  background: ${c.black};
  color: rgba(255, 255, 255, 0.94);

  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(201, 162, 39, 0.34);
  cursor: pointer;

  font-size: 16px;

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(201, 162, 39, 0.55);
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);
  }

  &:active {
    transform: translateY(0px);
    box-shadow: none;
  }
`;

export const Note = styled.p`
  margin: 6px 0 0;
  text-align: center;
  font-size: 12px;
  color: ${c.inkSoft};
`;

export const Message = styled.p`
  margin: 4px 0 0;
  text-align: center;
  font-size: 13px;

  color: ${(p) => (p.success ? "rgba(0,0,0,0.86)" : "#a94442")};
  border: 1px solid
    ${(p) => (p.success ? "rgba(201,162,39,0.35)" : "rgba(169,68,66,0.35)")};
  background: ${(p) =>
    p.success ? "rgba(201,162,39,0.08)" : "rgba(169,68,66,0.08)"};
  padding: 12px 14px;
  border-radius: 14px;
`;
